import { render } from "./EsEditAutoPrice.vue?vue&type=template&id=04fed509&scoped=true"
import script from "./EsEditAutoPrice.vue?vue&type=script&lang=js"
export * from "./EsEditAutoPrice.vue?vue&type=script&lang=js"

import "./EsEditAutoPrice.vue?vue&type=style&index=0&id=04fed509&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fed509"]])

export default __exports__